export enum CatalogBannerCollectionKind {
  Slider = "SLIDER",
  BannerLast = "CATALOG_BANNER_LAST",
  CollectionFirst = "CATALOG_COLLECTION_FIRST",
  CollectionLast = "CATALOG_COLLECTION_LAST",
  CollectionAudience = "CATALOG_COLLECTION_AUDIENCE",
}
